var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71539 5.51667L10.4819 6.28333L2.933 13.8333H2.16644V13.0667L9.71539 5.51667ZM12.715 0.5C12.5067 0.5 12.29 0.583333 12.1317 0.741667L10.6069 2.26667L13.7315 5.39167L15.2563 3.86667C15.5812 3.54167 15.5812 3.01667 15.2563 2.69167L13.3066 0.741667C13.1399 0.575 12.9316 0.5 12.715 0.5ZM9.71539 3.15833L0.5 12.375V15.5H3.62457L12.84 6.28333L9.71539 3.15833Z",
    fill: "#40668C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0b421ef2e33098e1c4469162717d6fcd.svg";
export { ForwardRef as ReactComponent };